import React, { useEffect } from 'react';
import { GenericStep } from '@/components/FullWidthTemplate/GenericStep';
import * as Styles from './ExternalDomain.styles';
import { IconCheck, IconWarning } from 'gatorcomponents';
import WpScreenBR from '@/media/onboarding/wp-ai-success-br.webp';

const ExternalDomain = ({
  locales, buttonsProps, imageSrc = WpScreenBR, cleanUp,
}) => {
  const componentProps = {
    testId: 'external-domain-step',
    buttonsProps,
    imageSrc,
  };

  useEffect(() => {
    cleanUp && cleanUp();
  }, [cleanUp]);

  return (
    <GenericStep {...componentProps}>
      <Styles.Wrapper>
        <Styles.TitleContainer>
          <IconWarning
            color="attentionExtraDark"
            size="lg"
          />
          <Styles.Title data-testid="external-domain-title">
            {locales.title}
          </Styles.Title>
        </Styles.TitleContainer>

        <Styles.Subtitle data-testid="external-domain-subtitle">{locales.subtitle}</Styles.Subtitle>

        <Styles.Info>
          <IconCheck color="primaryMedium" testId="external-domain-info-icon" />
          <Styles.Text data-testid="external-domain-info">{locales.info}</Styles.Text>
        </Styles.Info>

      </Styles.Wrapper>
    </GenericStep>
  );
};

export default ExternalDomain;
